import logo from './logo.svg';
import './App.css';
import { useSelector } from 'react-redux';
import ZipForm from './Components/ZipForm';
import Location from './Components/Location';

import Navbar from './Components/Navbar';

function App() {
  const {swap}=useSelector((store)=>store)
  return (
    <div className="App">
      <Navbar/>
      {
        !swap ?<ZipForm />:<Location />
      }
       
       
    </div>
  );
}

export default App;
